import React from 'react';

const InlineError = ({ text }) => (
    <span className="form-text">{text}</span>
);

export default InlineError;
